<template lang="pug">
v-card
  v-toolbar(color="primary", dark, flat)
    v-toolbar-title Descarga de los Registros de Inventarios
  v-card-text
    ValidationObserver(
      ref="observer_inventories_download",
      v-slot="{ validate, reset }"
    )
      v-form
        v-row
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              rules="required",
              name="StartDate"
            )
              v-menu(
                v-model="menu_date",
                :close-on-content-click="false",
                transition="scale-transition",
                offset-y,
                max-width="290px",
                min-width="290px",
                :error-messages="errors",
              )
                template(v-slot:activator="{ on }")
                  v-text-field(
                    v-model="dateFormatted_date",
                    label="Fecha Inicio",
                    clearable,
                    persistent-hint,
                    readonly,
                    v-on="on",
                    @click:clear="date = null"
                  )
                v-date-picker(
                  v-model="date",
                  no-title,
                  @input="menu_date = false"
                )
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              name="EndDate"
            )
              v-menu(
                v-model="menu_date_to",
                :close-on-content-click="false",
                transition="scale-transition",
                offset-y,
                max-width="290px",
                min-width="290px"
              )
                template(v-slot:activator="{ on }")
                  v-text-field(
                    v-model="dateFormatted_date_to",
                    label="Fecha Final",
                    clearable,
                    persistent-hint,
                    readonly,
                    v-on="on",
                    @click:clear="date_to = null"
                  )
                v-date-picker(
                  v-model="date_to",
                  no-title,
                  @input="menu_date_to = false"
                )
  v-card-actions
    v-spacer
    v-btn(
      color="secondary",
      @click="download",
      :loading="loading",
      :disabled="loading"
    ) Descargar
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import utils from "@/resources/utils";
import inventoryAPI from "@/api/inventories";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío"
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapState({
      auth_token: state => state.auth.auth_token
    }),
    dateFormatted_date() {
      return this.date
        ? moment(this.date)
            .locale("es")
            .format("LL")
        : "";
    },
    dateFormatted_date_to() {
      return this.date_to
        ? moment(this.date_to)
            .locale("es")
            .format("LL")
        : "";
    }
  },
  data() {
    return {
      loading: false,
      menu_date: false,
      date: null,
      menu_date_to: false,
      date_to: null,
    };
  },
  methods: {
    async download() {
      if (await this.$refs.observer_inventories_download.validate()) {
        this.loading = true
        const response = await inventoryAPI.downloadInventories(this.date, this.date_to, this.auth_token);
        this.loading = false

        if (response.status) {
        utils.downloadFiles(response.data, `Inventarios.xlsx`);
      }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
